import React, { useState } from "react";
import styles from "./stepFive.module.css";
import Header from "../../Header/Header";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../../config"; // Make sure this points to your config
import ProgressBar from "../../../components/ProgressBar";
import { showErrorToast } from "../../utils";

const StepFive = () => {
    const location = useLocation();
    const [firstQuestionAnswer, setFirstQuestionAnswer] = useState(null);
    const navigate = useNavigate();

    const handleOptionClick = (option) => {
        setFirstQuestionAnswer(option);
    };

    const handleGetQualifiedClick = async (e) => {
        e.preventDefault();

        // Validate that the user selected a credit score
        if (!firstQuestionAnswer) {
            showErrorToast("Please select a credit score.");
            return;
        }
        let formData = {
            credit_score: firstQuestionAnswer,
            ...location.state,
        };

        try {
            navigate("/get-qualified/Step-6", { state: formData }); // Redirect to Step-6 on success
        } catch (error) {
            console.error("Error submitting the form:", error);
            showErrorToast("An error occurred. Please try again.");
        }
    };

    return (
        <main className={`${styles.mainContainer} tw-h-screen tw-overflow-y-auto tw-bg-background_color`}>
            <Header title="Apply For Financing" />
            <section className={`${styles.formSection} tw-items-center`}>
                <ProgressBar currentStep={5} totalSteps={6} />
                <div className={`${styles.formContainer} tw-w-full max-lg:tw-w-[80%] tw-mt-10`}>
                    <form className={styles.generalForm} onSubmit={handleGetQualifiedClick}>
                        <h1 className={styles.formTitlelittle}>Credit score estimate</h1>
                        <p className={styles.formDescription}>
                            We check your credit score to help find the best loan options and interest rates that fit your needs. Your information is
                            safe with us and won’t be shared without your consent. For more details,{" "}
                            <a onClick={() => navigate("/privacy-policy")}>learn more about our privacy policy.</a>
                        </p>

                        <div className={`${styles.optionsContainer} ${styles.rowLayout}`}>
                            <p className={"tw-mb-2"}>What’s your credit score? Feel free to give us your best estimate.</p>
                            {["720 & above", "660-719", "620-659", "580-619", "579 or below", "Not Sure"].map((option, index) => (
                                <div
                                    key={index}
                                    className={`${styles.option} tw-w-full ${firstQuestionAnswer === option ? "tw-bg-primary hover:tw-bg-primary_hover tw-text-white" : ""}`}
                                    onClick={() => handleOptionClick(option)}
                                >
                                    {option}
                                </div>
                            ))}
                        </div>

                        <button type="submit" className={`${styles.submitButton} tw-bg-primary hover:tw-bg-primary_hover tw-text-white`}>
                            Next
                        </button>
                    </form>
                </div>
            </section>
        </main>
    );
};

export default StepFive;
